export const FICHA_CLIENTE_MODULE_ID = 'ficha_cliente'

export const ROLES_DEFAULT_FICHA_CLIENTE = ['ADMIN']

export function defaultFichaClienteAccess(roles) {
  return (roles || []).some((r) => ROLES_DEFAULT_FICHA_CLIENTE.includes(r))
}
